export default {
  /**
   * Errors
   */
  SET_ERROR (state, error) {
    state.isError = true
    state.error = error
  },

  CLEAR_ERROR (state) {
    state.isError = false
  },

  SHOW_ERROR_BUBBLE (state, value) {
    state.showErrorBubble = value
  },

  /**
   * Auth
   */
  LOGIN (state, response) {
    state.accessToken = response.data.access_token
    state.refreshToken = response.data.refresh_token
    state.expiresIn = response.data.expires_in
    state.adminId = response.data.admin_id
  },

  LOGOUT (state) {
    state.accessToken = null
    state.refreshToken = null
    state.expiresIn = null
    state.adminId = null
  },

  SET_AUTHENTICATED (state, value) {
    state.authenticated = value
  },

  /**
   * Clients
   */
  GET_CLIENT (state, response) {
    state.client = response.data
  },

  GET_CLIENTS (state, response) {
    state.clients = response.data.items
    state.clientsTotal = response.data.total
  },

  /**
   * Permissions
   */
  GET_PERMISSIONS (state, response) {
    state.permissions = response.data.items
    state.permissionsTotal = response.data.total
  },

  GET_CLIENT_PERMISSIONS (state, response) {
    state.clientPermissions = response.data.items
    state.clientPermissionsTotal = response.data.total
  },

  /**
   * Devices
   */
  GET_DEVICES (state, response) {
    state.devices = response.data.items
    state.devicesTotal = response.data.total
  },

  /**
   * Devices by platform
   */
  GET_ANDROID_DEVICES_TOTAL (state, response) {
    state.androidDevicesTotal = response.data.total
  },

  GET_IOS_DEVICES_TOTAL (state, response) {
    state.iosDevicesTotal = response.data.total
  },

  /**
   * Cameras
   */
  GET_CAMERAS (state, response) {
    state.cameras = response.data.items
    state.camerasTotal = response.data.total
  },

  /**
   * Cameras by manufacturer
   */
  GET_NOVATEK_CAMERAS_TOTAL (state, response) {
    state.novatekCamerasTotal = response.data.total
  },

  GET_AMBARELLA_CAMERAS_TOTAL (state, response) {
    state.ambarellaCamerasTotal = response.data.total
  },

  GET_AIT_CAMERAS_TOTAL (state, response) {
    state.aitCamerasTotal = response.data.total
  },

  GET_OTUS_CAMERAS_TOTAL (state, response) {
    state.otusCamerasTotal = response.data.total
  },

  GET_ICATCH_CAMERAS_TOTAL (state, response) {
    state.icatchCamerasTotal = response.data.total
  },

  GET_ETRON_CAMERAS_TOTAL (state, response) {
    state.etronCamerasTotal = response.data.total
  },

  /**
   * Client devices
   */
  GET_CLIENT_DEVICES (state, response) {
    state.clientDevices = response.data.items
    state.clientDevicesTotal = response.data.total
  },

  GET_CLIENT_DEVICES_BY_PERIODS (state, response) {
    state.clientDevicesByPeriods = response.data.items
  },

  /**
   * Client cameras
   */
  GET_CLIENT_CAMERAS (state, response) {
    state.clientCameras = response.data.items
    state.clientCamerasTotal = response.data.total
  },

  GET_CLIENT_CAMERAS_BY_PERIODS (state, response) {
    state.clientCamerasByPeriods = response.data.items
  },

  /**
   * Articles
   */
  GET_ARTICLE (state, response) {
    state.article = response.data
  },

  GET_CLIENT_ARTICLES (state, response) {
    state.clientArticles = response.data.items
    state.clientArticlesTotal = response.data.total
  },

  /**
   * Update
   */
  UPDATE_CLIENT (state, response) {
    state.client = response.data
  },

  UPDATE_ARTICLE (state, response) {
    state.article = response.data
  },

  /**
   * Create
   */
  CREATE_CLIENT (state, response) {
    state.client = response.data
  },

  CREATE_ARTICLE (state, response) {
    state.article = response.data
  },

  /**
   * File upload
   */
  UPLOAD_FILE (state, response) {
    state.file = response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js